import { ToWords } from 'to-words';
const toWords = new ToWords({ localeCode: 'en-US' });
import { formatToCurrency } from '@/lib/helpers';

export const generateLoanReviewChecklist = (data) => {
  data.loan['loanAmountInWords'] = toWords
    .convert(data?.loan.loanAmount || 0, { currency: true, doNotAddOnly: true })
    .toUpperCase();
  data.loan.loanAmountInCurrency = formatToCurrency(data?.loan.loanAmount);
  const systemCheckListItems = data?.loan?.systemCheckListItems || [];

  const borderColor = '#9ca3af';
  const bigMargin = 20;

  const branchName = data.user?.branch?.branchName || '';
  const branchAddress = `${data?.user?.branch?.branchStreet} ${data?.user?.branch?.branchCity} ${data?.user?.branch?.branchProvince} ${data?.user?.branch?.branchCountry}`;
  // Get the main branch phone number
  const branchPhones = () => {
    if (!data?.user?.branch?.branchTelephone) return '';
    const mainBranch = data?.user?.branch?.branchTelephone.find(
      (t) => t.isMain == true
    );
    if (!mainBranch) return '';
    return mainBranch.number;
  };
  const accountHolders = () => {
    if (!data.loan?.loanDistributions) return '';
    return data.loan?.loanDistributions
      .map(
        (d) =>
          `${d.person?.firstName} ${d.person?.middleName} ${d.person?.lastName}`
      )
      .join(', ');
  };
  const tableLayout = {
    hLineColor: borderColor,
    vLineColor: borderColor,
    paddingBottom: () => 4,
    paddingTop: () => 4,
    paddingLeft: () => 8,
    paddingRight: () => 8
  };
  /**@type {import('pdfmake/interfaces').TDocumentDefinitions} */
  const dd = {
    footer: function (currentPage, pageCount) {
      return {
        text: `Page ${currentPage.toString()} of ${pageCount.toString()}`,
        alignment: 'center'
      };
    },
    info: {
      title: 'Loan Review Checklist', // name of the document being printed
      modDate: new Date(), // date the document was last modified
      creationDate: new Date(), // date the document was created
      keywords: 'lrc, loan, finance', // keywords associated with the document
      author: data.company?.name, // company name
      subject: 'Loan Review Checklist', // name of the document being printed
      creator: data.user?.username, // name of the logged in user
      producer: data.company?.name // company name
    },

    content: [
      data.company?.companyImage && {
        image: 'companyImage',
        alignment: 'center',
        fit: [80, 80]
      },
      {
        marginTop: 20,
        text: data.company?.name,
        alignment: 'center',
        fontSize: 22,
        bold: true
      },
      {
        text: 'Reviewal Review',
        alignment: 'center',
        fontSize: 14,
        marginBottom: 10,
        bold: true
      },
      { text: branchName, alignment: 'center' },
      { alignment: 'center', text: branchAddress },
      { alignment: 'center', text: branchPhones() },
      {
        marginTop: 30,
        text: `Account No. ${data?.loan.mainAccountNumber}`,
        bold: false
      },
      { text: accountHolders() },

      {
        marginTop: bigMargin,
        columns: [
          { text: 'Total Loan Amount:' },
          { text: data?.loan.loanAmountInCurrency, alignment: 'right' }
        ]
      },

      {
        columns: [
          { text: 'Interest Rate (Annual):' },
          { text: `${data?.loan.interest}%`, alignment: 'right' }
        ]
      },
      {
        columns: [
          { text: 'Tenure:' },
          { text: `${data?.loan.tenure}`, alignment: 'right' }
        ]
      },
      {
        columns: [
          { text: `Payment (${data?.loan.frequencyName}):` },
          {
            text: formatToCurrency(data?.loan.frequencyPayment),
            alignment: 'right'
          }
        ]
      },
      {
        columns: [
          { text: 'Loan Product:' },
          { text: `${data?.loan.loanProduct}`, alignment: 'right' }
        ]
      },

      {
        table: {
          widths: ['*', '*', '*', '*', '*'],
          body: [
            [
              {
                text: 'Item Code',
                bold: false
              },
              {
                text: 'Item',
                bold: false
              },
              {
                text: 'Item Type',
                bold: false
              },
              {
                text: 'Priority',
                bold: false
              },
              {
                text: 'Status',
                bold: false
              }
            ],

            ...systemCheckListItems
              .filter((item) =>
                item.requiredStage?.toLowerCase().trim().includes('review')
              )
              .map((item) => {
                return [
                  item.checklistCode,
                  item.checklistName,
                  item.checklistType,
                  item.priority,
                  item.active ? 'Active' : 'Inactivated'
                ];
              })
          ]
        },
        layout: {
          hLineWidth: function (i, node) {
            return 0.2;
          },
          vLineWidth: function (i, node) {
            return 0.2;
          },
          hLineColor: function (i, node) {
            return 'black';
          }
        },
        margin: [0, 20, 0, 20]
      },
      { text: 'Signature', marginTop: bigMargin, bold: true },
      {
        marginTop: 15,
        columns: [
          { text: '_______________________________', font: 'Roboto' },
          {
            text: '_______________________________',
            font: 'Roboto',
            alignment: 'right'
          }
        ]
      },
      {
        marginTop: 10,
        columns: [
          {
            text: `Prepared by: ${data.user?.username}`,
            style: 'supSignature',
            alignment: 'left'
          },
          { text: 'Date Signed', alignment: 'right', style: 'supSignature' }
        ]
      }
    ],

    images: {
      companyImage: data.company?.companyImage
    },
    styles: {
      tableHeader: {
        bold: true
      },
      supSignature: {
        fontSize: 18,
        sup: true,
        alignment: 'center'
      },
      tableHeading: {
        alignment: 'left',
        fontSize: 16,
        bold: true
      }
    },
    defaultStyle: {
      font: 'Lora',
      color: '#111827',
      fontSize: 11,
      lineHeight: 1.3
    }
  };
  return dd;
};
